<template>
    <div class="event-login">
        <div class="close cursor" @click="closeLoginModel"></div>
        <div class="cnt">
            <div class="title"></div>
            <div class="b-bg position-relative">
                <div class="b-cnt">

                    <regLogin :isEventPageLogin="true" @handleInfoAgain="handleInfoAgain" />

                    <!-- 提示内容 -->
                    <div class="info mt-24 cursor"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import regLogin from '../regLogin.vue'
export default {
    components: {
        regLogin
    },
    data() {
        return {


        }
    },
    methods: {
        closeLoginModel() {
            this.$emit('taskLoginModelClose', false)
        },

        // 登陆成功后，再次走info
        handleInfoAgain(isNew) {

            this.$emit('handleEventLoginAgain',isNew)

        },

    }
}
</script>
<style  lang="scss">
.event-login {
    background: url("../../../assets/img/common/model-bg.png") no-repeat top;
    background-size: 100% 100%;
    width: 929px;
    height: 548px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .close {
        background: url("../../../assets/img/common/close.png") no-repeat top;
        background-size: 100% 100%;
        width: 56px;
        height: 49px;
        position: absolute;
        right: 0;
        top: -49px;

    }

    .title {
        background: url("../../../assets/img/m4/login/login-title.png") no-repeat top;
        background-size: 100% 100%;
        width: 526px;
        height: 41px;
        margin: 36px auto 20px auto;
        text-align: center;
    }

    .b-bg {
        background-color: #000000;
        width: 80%;
        margin: 0 auto;
        padding: 36px 0;

        .info {
            background: url("../../../assets/img/m4/info.png") no-repeat top;
            background-size: 100% 100%;
            width: 496px;
            height: 43px;
            margin: 36px auto 0 auto;
        }
    }



}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/eventComponents/eventLogin.vue